<template>
  <vs-row v-if="data">
    <vs-col>
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="1" vs-justify="center" vs-align="center">
          <h2>{{ $t('reports.registrations.total') }}</h2>
        </vs-col>
        <vs-col vs-w="11">
          <vs-row>
            <vs-col :vs-w="columnSize" class="p-3">
              <registrations-statistics-card :data="data" :color="'primary'" :icon="'UsersIcon'"
                                             :label="$t('reports.global.programs.all')"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('MENTAL_FITNESS')">
              <registrations-statistics-card :data="data" :program="'MENTAL_FITNESS'" :color="'success'" :icon="'CloudIcon'"
                                             :label="$t('reports.global.programs.MENTAL_FITNESS')"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_MENTAL')">
              <registrations-statistics-card :data="data" :program="'RTH_MENTAL'" :color="'warning'" :icon="'CloudDrizzleIcon'"
                                             :label="$t('reports.global.programs.RTH_MENTAL')"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_PHYSICAL')">
              <registrations-statistics-card :data="data" :program="'RTH_PHYSICAL'" :color="'danger'" :icon="'CloudLightningIcon'"
                                             :label="$t('reports.global.programs.RTH_PHYSICAL')"/>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col>
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="1" vs-justify="center" vs-align="center">
          <h2>{{ $t('reports.registrations.month') }}</h2>
        </vs-col>
        <vs-col vs-w="11">
          <vs-row>
            <vs-col :vs-w="columnSize" class="p-3">
              <registrations-trend-card :data="data" :color="'primary'"
                                        :label="$t('reports.global.programs.all')"
                                        :period="'MONTH'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('MENTAL_FITNESS')">
              <registrations-trend-card :data="data" :program="'MENTAL_FITNESS'" :color="'success'"
                                        :label="$t('reports.global.programs.MENTAL_FITNESS')"
                                        :period="'MONTH'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_MENTAL')">
              <registrations-trend-card :data="data" :program="'RTH_MENTAL'" :color="'warning'"
                                        :label="$t('reports.global.programs.RTH_MENTAL')"
                                        :period="'MONTH'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_PHYSICAL')">
              <registrations-trend-card :data="data" :program="'RTH_PHYSICAL'" :color="'danger'"
                                        :label="$t('reports.global.programs.RTH_PHYSICAL')"
                                        :period="'MONTH'"/>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>

    <vs-col>
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="1" vs-justify="center" vs-align="center">
          <h2>{{ $t('reports.registrations.quarter') }}</h2>
        </vs-col>
        <vs-col vs-w="11">
          <vs-row>
            <vs-col :vs-w="columnSize" class="p-3">
              <registrations-trend-card :data="data" :color="'primary'"
                                        :label="$t('reports.global.programs.all')"
                                        :period="'QUARTER'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('MENTAL_FITNESS')">
              <registrations-trend-card :data="data" :program="'MENTAL_FITNESS'"
                                        :color="'success'"
                                        :label="$t('reports.global.programs.MENTAL_FITNESS')"
                                        :period="'QUARTER'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_MENTAL')">
              <registrations-trend-card :data="data" :program="'RTH_MENTAL'"
                                        :color="'warning'"
                                        :label="$t('reports.global.programs.RTH_MENTAL')"
                                        :period="'QUARTER'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_PHYSICAL')">
              <registrations-trend-card :data="data" :program="'RTH_PHYSICAL'"
                                        :color="'danger'"
                                        :label="$t('reports.global.programs.RTH_PHYSICAL')"
                                        :period="'QUARTER'"/>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>

    <vs-col>
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="1" vs-justify="center" vs-align="center">
          <h2>{{ $t('reports.registrations.year') }}</h2>
        </vs-col>
        <vs-col vs-w="11">
          <vs-row>
            <vs-col :vs-w="columnSize" class="p-3">
              <registrations-trend-card :data="data"
                                        :color="'primary'"
                                        :label="$t('reports.global.programs.all')"
                                        :period="'YEAR'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('MENTAL_FITNESS')">
              <registrations-trend-card :data="data" :program="'MENTAL_FITNESS'"
                                        :color="'success'"
                                        :label="$t('reports.global.programs.MENTAL_FITNESS')"
                                        :period="'YEAR'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_MENTAL')">
              <registrations-trend-card :data="data"
                                        :program="'RTH_MENTAL'"
                                        :color="'warning'"
                                        :label="$t('reports.global.programs.RTH_MENTAL')"
                                        :period="'YEAR'"/>
            </vs-col>
            <vs-col :vs-w="columnSize" class="p-3" v-if="hasProgram('RTH_PHYSICAL')">
              <registrations-trend-card :data="data"
                                        :program="'RTH_PHYSICAL'"
                                        :color="'danger'"
                                        :label="$t('reports.global.programs.RTH_PHYSICAL')"
                                        :period="'YEAR'"/>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import RegistrationsStatisticsCard from './graphs/registrations-statistics-card';
import RegistrationsType from './graphs/registrations-type';
import RegistrationsTrendCard from './graphs/registrations-trend-card';
import {ResourceImpl} from 'hal-client';
import Vue from 'vue';

export default {
  name: 'analysis-registrations',
  components: {
    RegistrationsTrendCard,
    RegistrationsType,
    RegistrationsStatisticsCard
  },
  props: {
    resource: ResourceImpl,
    date: String,
    filters: Object,
    bus: Vue
  },
  data () {
    return {data: null};
  },
  computed: {
    partial () {
      return this.date && this.date === 'CURRENT';
    },
    programs () {
      const root = this.data.analysis.find(n => n.name === 'ROOT');
      const allTime = root.nested.find(n => n.name === 'ALL_TIME');
      const programs = allTime.nested.find(n => n.name === 'PROGRAMS');
      return programs.buckets.map(b => b.key);
    },
    columnSize () {
      switch (this.programs.length) {
      case 1 :
        return 6;
      case 2:
        return 4;
      case 3:
        return 3;
      default:
        return 3;
      }
    }
  },
  created () {
    this.bus.$on('refresh', this.refresh);
  },
  mounted () {
    this.refresh();
  },
  destroyed () {
    this.bus.$off('refresh', this.refresh);
  },
  methods: {
    hasProgram (program) {
      return this.programs.indexOf(program) >= 0;
    },
    refresh () {
      if (this.resource.$has('registrations')) {
        const params = {
          ...this.filters,
          date: this.date
        };
        this.resource.$request().$get('registrations', params).then(res => {
          this.data = res;
        });
      }
    }
  }
};
</script>

<style scoped>

</style>
